(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-games-ae-1"] && !Shopify.designMode) return;
  try {
    
$(function() {
  var $stickyNav = $("#header-sticky-nav");
  var intersectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.intersectionRatio <= 0) {
        $stickyNav.fadeIn();
      }
      else {
        $stickyNav.hide();
      }
    });
  });
  var hideFor = document.querySelectorAll([".home-games-ae-1, .home-games-ae-7"]);
  hideFor.forEach((el) => {
    intersectionObserver.observe(el);
  });
});

  } catch(e) { console.error(e); }
})();
})();
